import { useContext, useEffect, useState } from 'react';

import { useNavigate } from 'react-router';
import { Link } from 'react-router-dom';
import * as Yup from 'yup';

import { Form, Select, Text } from '../../../Components/Form';
import Loading from '../../../Components/Loading/Loading';
import { useApi } from '../../../Hooks/Api';
import { useToast } from '../../../Hooks/Toast';
import Master from '../../../Layouts/Master';
import { getMedal, getRank, serverErrorHandler } from '../../../Utils/Helpers';
import { RankContext } from '../Context/RankContext';

const validationSchema = Yup.object({
  national_card_id: Yup.string()
    .required('کد ملی الزامی است')
    .min(10, 'کد ملی باید 10 رقم باشد')
    .max(10, 'کد ملی باید 10 رقم باشد'),
  competition_id: Yup.number()
    .typeError('انتخاب مسابقه الزامی است')
    .required('انتخاب مسابقه الزامی است'),
  // sport_id: Yup.number()
  //   .typeError('انتخاب رشته الزامی است')
  //   .required('انتخاب رشته الزامی است'),
  // type: Yup.number()
  //   .typeError('انتخاب نوع مسابقه الزامی است')
  //   .required('انتخاب نوع مسابقه الزامی است'),
});

const Print = () => {
  const [formSubmitLoading, setFormSubmitLoaing] = useState(false);
  const [loading, setLoading] = useState(true);
  const [serverErrors, setServerErrors] = useState({});
  const { get } = useApi();
  const { error } = useToast();
  const navigate = useNavigate();
  const context = useContext(RankContext);
  const [sportLoading, setSportLoading] = useState(false);

  useEffect(() => {
    const getData = async () => {
      await getCompetitions();
    };
    getData();
  }, []);

  const getCompetitions = async () => {
    setLoading(true);
    await get(
      '/competition?all=true',
      (res) => {
        context.competitions = res.data;
        setLoading(false);
      },
      (err) => {
        setLoading(false);
        error('دریافت اطلاعات ناموفق بود.');
      },
    );
  };

  const getRanks = async (values) => {
    setServerErrors({});
    setFormSubmitLoaing(true);
    await get(
      `/rank?competition_id=${values['competition_id']}&national_card_id=${values['national_card_id']}`,
      (res) => {
        context.ranks = res.data;
        setFormSubmitLoaing(false);
      },
      (err) => {
        setFormSubmitLoaing(false);
        if (err?.status === 422 || err.status === 400) {
          serverErrorHandler(err?.data?.errors, setServerErrors, serverErrors);
          error('لطفا خطاها را رفع کنید.');
        } else {
          error('دریافت اطلاعات با خطا روبرو شد.');
        }
      },
    );
  };

  const getCompetition = async (competitionId) => {
    if (competitionId == 'انتخاب مسابقه') return;
    setSportLoading(true);
    await get(
      `/competition/${competitionId}`,
      (res) => {
        context.sports = res?.data?.sports;
        context.types = res?.data?.type;
        setSportLoading(false);
      },
      (err) => {
        error('خطا هنگام دریافت اطلاعات');
        setSportLoading(false);
      },
    );
  };

  const onSubmit = async (values) => {
    setServerErrors({});
    setFormSubmitLoaing(true);

    await get(
      `/competition/${values.competition_id}/user/rank?sport_id=${values?.sport_id}&national_card_id=${values?.national_card_id}&type=${values?.type}`,
      (res) => {
        if (res.error) {
          setFormSubmitLoaing(false);
          return error(res?.message);
        }
        setFormSubmitLoaing(false);

        return navigate(`/id-card/competition/${values?.competition_id}/rank`, {
          state: {
            user: res?.data,
            sport: res?.data?.sport,
            weight: res?.data?.weight,
            type: values?.type,
          },
        });
      },
      (err) => {
        setFormSubmitLoaing(false);
        if (err?.status === 422 || err.status === 400) {
          serverErrorHandler(err?.data?.errors, setServerErrors, serverErrors);
          error('لطفا خطاهای فرم را رفع کنید.');
        } else {
          error('دریافت اطلاعات با خطا روبرو شد.');
        }
      },
    );
  };

  return loading ? (
    <Loading />
  ) : (
    <Master showSidebar={false} headerFixed={true} containerFullWidth={true}>
      <section className='image-cover pt-4'>
        <div className='container py-5 bg-sky-light shadow-sm rounded-1'>
          <Form
            initialValues={{
              competition_id: '',
              national_card_id: '',
            }}
            onSubmit={getRanks}
            validationSchema={validationSchema}
            defaultActions={false}
          >
            <div className='row'>
              <div className='col-12 col-md-6'>
                <Text
                  title='کد ملی'
                  name='national_card_id'
                  serverError={serverErrors?.national_card_id}
                />
              </div>
              <div className='col-12 col-md-6'>
                <Select
                  title='مسابقه'
                  name='competition_id'
                  optionLabel='title'
                  optionValue='id'
                  onChange={async (value) => getCompetition(value)}
                  options={context.competitions}
                  serverError={serverErrors?.competition_id}
                />
              </div>
              {/* <div className='col-12 col-md-6'>
                {sportLoading ? (
                  <div className='w-100 d-flex flex-row justify-content-center'>
                    <div
                      className='spinner-border text-dark spinner-border-sm mb-1'
                      role='status'
                    >
                      <span className='sr-only'></span>
                    </div>
                  </div>
                ) : (
                  <Select
                    title='رشته'
                    name='sport_id'
                    optionLabel='title'
                    optionValue='id'
                    options={context.sports}
                    serverError={serverErrors?.sport_id}
                  />
                )}
              </div> */}

              {/* <div className='col-12 col-md-6'>
                {sportLoading ? (
                  <div className='w-100 d-flex flex-row justify-content-center'>
                    <div
                      className='spinner-border text-dark spinner-border-sm mb-1'
                      role='status'
                    >
                      <span className='sr-only'></span>
                    </div>
                  </div>
                ) : (
                  <Select
                    title='نوع مسابقه'
                    name='type'
                    optionLabel='label'
                    optionValue='value'
                    options={[
                      { value: 1, label: 'انفرادی' },
                      { value: 2, label: 'تیمی' },
                      { value: 3, label: 'لیگ' },
                    ]}
                    serverError={serverErrors?.type}
                  />
                )}
              </div> */}
            </div>
            <div className='col-12'>
              <div className='d-flex flex-row justify-content-center align-items-center my-3'>
                {formSubmitLoading ? (
                  <button
                    type='button'
                    className='btn f-12 bg-persian-green text-white py-2 px-3'
                  >
                    <div
                      className='spinner-border text-white spinner-border-sm mb-1'
                      role='status'
                    >
                      <span className='sr-only'></span>
                    </div>
                  </button>
                ) : (
                  <button
                    type='submit'
                    className='btn f-12 bg-persian-green text-white py-2 px-3'
                  >
                    نمایش حکم
                  </button>
                )}
              </div>
            </div>
          </Form>
          <div className='row mx-2 overflow-auto'>
            {context?.ranks?.length > 0 ? (
              <table
                className='table table-striped my-3 text-left'
                style={{ minWidth: '992px' }}
              >
                <thead>
                  <tr className='bg-purple text-white'>
                    <th scope='col'>#</th>
                    <th scope='col'>نام و نام خانوادگی</th>
                    <th scope='col'>کد ملی</th>
                    <th scope='col'>مسابقه</th>
                    <th scope='col'>وزن</th>
                    <th scope='col'>رشته</th>
                    <th scope='col'>رده سنی</th>
                    <th scope='col'>نوع</th>
                    <th scope='col'>مقام</th>
                    <th scope='col'>مدال</th>
                    <th scope='col'>نمایش حکم</th>
                  </tr>
                </thead>
                <tbody>
                  {context?.ranks?.map((rank, index) => (
                    <tr key={'ranks-' + rank?.id}>
                      <th scope='row'>{index + 1}</th>
                      <td>
                        {rank?.user?.name} {rank?.user?.last_name}
                      </td>
                      <td>{rank?.user?.national_card_id}</td>
                      <td>{rank?.competition?.title}</td>
                      <td>{rank?.weight?.weight}</td>
                      <td>{rank?.sport?.title}</td>
                      <td>{rank?.age?.title}</td>
                      <td>
                        {rank?.user && !rank?.team && !rank?.league
                          ? 'انفرادی'
                          : rank?.team && !rank?.league
                          ? 'تیمی'
                          : !rank?.team && rank?.league
                          ? 'لیگ'
                          : ''}
                      </td>
                      <td>{getRank(rank?.rank)}</td>
                      <td>{getMedal(rank?.rank)}</td>
                      <td className='text-center'>
                        <Link
                          to={`/id-card/competition/${rank?.competition?.id}/rank`}
                          state={{
                            user: rank?.user,
                            sport: rank?.sport,
                            weight: rank?.weight,
                            type:
                              rank?.user && !rank?.team && !rank?.league
                                ? 1
                                : rank?.team && !rank?.league
                                ? 2
                                : !rank?.team && rank?.league
                                ? 3
                                : undefined,
                          }}
                        >
                          {' '}
                          <i className='fad fa-eye text-info f-24 c-pointer'></i>
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div className='w-100 d-flex flex-row justify-content-center align-items-center my-3'>
                اطلاعاتی جهت نمایش یافت نشد.
              </div>
            )}
          </div>
        </div>
      </section>
    </Master>
  );
};

export default Print;
